import { useEffect, useState } from 'react';
import { getUserProfile, getUserIndividual } from '../services/resource-server/resource-server';

export default function Profile() {
    const [profile, setProfile] = useState<any>(null);
    const [individual, setIndividual] = useState<any>(null);

    useEffect(() => {
        const fetchData = async () => {
            const p = await getUserProfile();
            setProfile(p);
            const ind = await getUserIndividual();
            console.log('getUserIndividual response:', ind);
            setIndividual(ind);
        };
        fetchData();
    }, []);

    return (
        <>
            <div className="drop-shadow-content-box">
                <h2>Profile</h2>
                {profile ? (
                    <div>
                        <p><strong>First Name:</strong> {profile.first_name}</p>
                        <p><strong>Last Name:</strong> {profile.last_name}</p>
                        <p><strong>Username:</strong> {profile.username}</p>
                        <p><strong>Email:</strong> {profile.email}</p>
                        <p><strong>User Type:</strong> {individual?.user_type ?? 'Unknown'}</p>
                    </div>
                ) : (
                    <p>Loading...</p>
                )}
            </div>
        </>
    );
}
